import flattenDeep from 'lodash/flattenDeep';
import React from 'react';
import { Route, Routes as ReactRoutes } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { SnackbarProvider, useSnackbar } from 'notistack';

const generateFlattenRoutes = (routes) => {
  if (!routes) return [];
  return flattenDeep(routes.map(({ routes: subRoutes, ...rest }) => [rest, generateFlattenRoutes(subRoutes)]));
}

export const renderRoutes = (mainRoutes) => {
  const Routes = ({ isAuthorized }) => {
    const layouts = mainRoutes.map(({ layout: Layout, routes }, index) => {
      const subRoutes = generateFlattenRoutes(routes);
      
      return (
      
        <Route key={index} element={<Layout />}>
            
        
            {subRoutes.map(({ component: Component, path, name, isPublic }) => {
              return (               
                <Route key={name} element={<ProtectedRoute isPublic={isPublic} isAuthorized={isAuthorized} />}>
                Component && path && (<Route  key={name} element={<Component />}  path={path} />)
                </Route>
              )
            })}
            
          
        </Route>
        
      )
    });
    
    return  <SnackbarProvider maxSnack={6}  anchorOrigin={{vertical: 'bottom',horizontal: 'right',}}>
                <ReactRoutes>{layouts}</ReactRoutes>
            </SnackbarProvider>;
  }
  return Routes;
}